<template>
    <div class="forgot-password-holder">
        <a :href="link">{{forgot}}</a>
    </div>
</template>

<script setup>
defineProps({
    link: {
        type: String,
        required: true
    },
    forgot: {
        type: String,
        required: true
    }
});
</script>

<style scoped>
.forgot-password-holder {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    display: flex;
    align-items: center;
    padding-left: 10px;
    padding-right: 10px;
}

.forgot-password-holder a {
    text-transform: uppercase;
    font-weight: 700;
}
</style>
